export default __webpack_public_path__ + "static/media/coffin.0c7bb0e0.png";